import http from '@/http';

export default {

    list() {
        return http.get('/persons');
    },
    fetch(id) {
        return http.get(`/persons/${id}`);
    },
    save(form) {
        return http.post('/persons', form);
    },
    update(id, form) {
        return http.put(`/persons/${id}`, form);
    },
};



// WEBPACK FOOTER //
// ./src/api/persons.js